export default __webpack_public_path__ + "static/media/4.d43cafd4.svg";